(function () {
    'use strict';

    angular.module('app.designTemplate', ['ui.tree']);
})();